import { loginTypeState, periodState } from '@/features/authSlice'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

export const usePeriod = ({ campaign }: { campaign: Api.CampaignResBody }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [PeriodState, setPeriodState] = useState(undefined)
  // キャンペーンが開催中: campaignIsOpen = true
  // 他のuseStateは信用に値しないので仮で新しいuseStateを使っている。
  // 今後、安全に削除できることを確認できたら、以下のstateだけにする
  // localStorage周りの修正もしたかったが、地味に色々なところで使われているので、一旦このままにしてある
  const [campaignIsOpen, setCampaignIsOpen] = useState<boolean>(false)
  const [loadingCampaignIsOpen, setLoadingCampaignIsOpen] = useState<boolean>(true)
  const { LOCAL_STORAGE_PERIOD_KEY, campaignSlug } = useCampaignSlug()

  const handlePeriod = (campaign) => {
    if (campaign === 'notice') {
      localStorage.setItem(LOCAL_STORAGE_PERIOD_KEY, 'false')

      if (router.pathname === '/notice') {
        dispatch(periodState(true))
      } else {
        location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${campaignSlug}/notice`
      }

      return
    }

    if (campaign === false) {
      localStorage.setItem(LOCAL_STORAGE_PERIOD_KEY, 'false')
    }
  }

  useEffect(() => {
    if (campaign && campaign.campaignEndAt !== '') {
      setPeriodState(campaign)
    }
    if (campaign && campaign.campaignEndAt !== '') {
      const currentDate = new Date()
      const startDate = new Date(campaign.campaignStartAt)
      const endDate = new Date(campaign.campaignEndAt)
      if (startDate < currentDate && currentDate < endDate) {
        dispatch(periodState(true))
        setCampaignIsOpen(true)
      } else {
        dispatch(periodState(false))
        setCampaignIsOpen(false)
      }
      setLoadingCampaignIsOpen(false)
    }
  }, [campaign])

  useEffect(() => {
    if (PeriodState !== undefined) {
      dispatch(loginTypeState(PeriodState.loginType))

      if (PeriodState.period === false) {
        dispatch(periodState(false))
        handlePeriod(PeriodState.period)
        return
      }

      if (PeriodState.outOfTermMessage !== null) {
        localStorage.removeItem(LOCAL_STORAGE_PERIOD_KEY)

        dispatch(periodState(false))
        handlePeriod('notice')

        return
      }

      localStorage.removeItem(LOCAL_STORAGE_PERIOD_KEY)
      dispatch(periodState(true))

      return
    }
  }, [PeriodState])

  return { campaignIsOpen, loadingCampaignIsOpen }
}
